import { ITimeOffState } from '@/store/timeoff';
import { ITimeOffMutations } from './mutations.types';
import {
  ITimeOffRequestData,
  ITimeOffPolicyData,
  ITimeOffTemplateData,
  ITimeOffTypeData
} from '@/models';

export const mutations: ITimeOffMutations = {
  SET_COUNT(state: ITimeOffState, payload: number): void {
    state.count = payload;
  },

  INCREMENT_COUNT(state: ITimeOffState): void {
    state.count += 1;
  },

  DECREMENT_COUNT(state: ITimeOffState): void {
    state.count -= 1;
  },

  SET_LAST_PROMISE(state: ITimeOffState, payload: Promise<any>): void {
    state.lastPromise = payload;
  },

  SET_TIME_OFF_TYPES(state: ITimeOffState, payload: ITimeOffTypeData[]): void {
    state.timeOffTypes = payload;
  },

  SET_TIME_OFF_TEMPLATES(
    state: ITimeOffState,
    payload: ITimeOffTemplateData[]
  ): void {
    state.templates = payload;
  },

  ADD_TIME_OFF_TEMPLATE(
    state: ITimeOffState,
    payload: ITimeOffTemplateData
  ): void {
    state.templates.push(payload);
  },

  UPDATE_TIME_OFF_TEMPLATE(
    state: ITimeOffState,
    payload: ITimeOffTemplateData
  ): void {
    const index = state.templates.findIndex(
      (timeOffTemplate: ITimeOffTemplateData) =>
        timeOffTemplate.id === payload.id
    );

    state.templates.splice(index, 1, payload);
  },

  SET_TIME_OFF_POLICIES(
    state: ITimeOffState,
    payload: ITimeOffPolicyData[]
  ): void {
    state.timeOffPolicies = payload;
  },

  ADD_TIME_OFF_POLICY(state: ITimeOffState, payload: ITimeOffPolicyData): void {
    state.timeOffPolicies.push(payload);
  },

  UPDATE_TIME_OFF_POLICY(
    state: ITimeOffState,
    payload: ITimeOffPolicyData
  ): void {
    const index = state.timeOffPolicies.findIndex(
      (timeOff: ITimeOffPolicyData) => timeOff.id === payload.id
    );

    state.timeOffPolicies.splice(index, 1, payload);
  },

  REMOVE_TIME_OFF_POLICY(state: ITimeOffState, payload: number): void {
    const index = state.timeOffPolicies.findIndex(
      (timeOff: ITimeOffPolicyData) => timeOff.id === payload
    );

    state.timeOffPolicies.splice(index, 1);
  }
};
